import { NgModule } from '@angular/core';
import { BillingBlockComponent } from '@experience/landing/common/components/billing-blocks/billing-block.component';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarModule } from 'primeng/progressbar';
import { SharedModule } from '@support/shared/shared.module';
import { SharedExperienceModule } from '@experience/shared-experience/shared-experience.module';
import { CommonModule } from '@angular/common';
import { AemModule } from '@core/aem';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    AemModule,
    WidgetsModule,
    ProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    SharedExperienceModule,
    RouterModule,
  ],
  declarations: [BillingBlockComponent],
  exports: [BillingBlockComponent],
})
export class BillingBlockLandingModule {}
